// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shippingDetails":"shippingDetails___3qxVu","shippingCost":"shippingCost___FrBmL"};